import { useMemo } from 'react';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { rage, useObservable } from '~/rage';
import { JobDefinitions } from '../../views/Jobs/Jobs.model';
import { StyledContainer } from './Background.styled';

const Background = () => {
	const jobId = useObservable(rage.jobs.getOpenedJobId());
	const jobConfig = useMemo(
		() => (jobId ? JobDefinitions[jobId] : null),
		[jobId],
	);

	if (!jobConfig) {
		return null;
	}

	return (
		<StyledContainer>
			{rage.config.isStub() && (
				<BgPlaceholder $type={PlaceholderType.Default} />
			)}
		</StyledContainer>
	);
};

export { Background };
